<div class="inbuilt-report-wrapper p-relative" >
    <div class="inbuilt-loader-container" *ngIf="isPageChanging">
        <div class="loader"><app-loader></app-loader></div>
    </div>
    <div class="main-div-with-gray-bkg inbuilt-report-container pt-3"  *ngIf="showView">
        <div class="row" *ngIf="reportNameFromInput == ''">
            <div class="col-12">
                <div class="breadcrumb-div d-flex align-items-center justify-content-end">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item cursor-pointer"><a [routerLink]="['/landing-page']">Home</a></li>
                            <li class="breadcrumb-item cursor-pointer" [routerLink]="['/reports']" aria-current="page">
                                Reports</li>
                            <li class="breadcrumb-item active" aria-current="page">{{reportNameFromQueryParams | titlecase}}
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
        <!-- remove below section-->
        <!-- <ng-container *ngIf="initialDataLoaded && false">
            <div class="row main-block p-relative">
                <div class="col-12">
                    
                </div>
                <div class="col-12">
                    <mat-tab-group (selectedTabChange)="reportTabChange($event)" aria-label="Reports Tabs" role="tablist"
                        [ngClass]="{'hide-tab': isTabLabelEmpty}">
                        <mat-tab *ngFor="let tab of tabs" [label]="tab.name" role="tab">
                            <ng-container *ngIf="selectedTab.value === tab.value">
                                <ng-container *ngIf="allFilters && allFilters.length > 0">
                                    <app-inbuilt-filters [showView]="showView" [allFilters]="allFilters" (setTableValues)="setTableValues($event,tab.value)"
                                        (updateFieldList)="updateFieldList($event)"
                                        [cascadeData]="cascadeData"></app-inbuilt-filters>
                                </ng-container>
                            </ng-container>
                        </mat-tab>
                    </mat-tab-group>
                </div>
    
                <div class="documentation-icon">
                    <button [attr.Pixel-tracking]="true" [attr.Pixel-title]="'Documentation'"
                        class="uitk-icon uitk-icon-info_hollow md-icon no-border me-2  cursor-pointer" title="Info"
                        (click)="info()">
                    </button>
                </div>
    
            </div>
            <div class="row  mt-4">
                <div class="col-12 main-block" *ngIf="showTable && !showLoader">
                    <app-inbuilt-table [columns]="columns" [reportNameFromQueryParams]="reportNameFromQueryParams"
                        [tableData]="filteredTableData"  [currentDate]="currentDate"
                        [currentTime]="currentTime" (refreshTable)="refreshTableData($event)"></app-inbuilt-table>
                </div>
                <ng-container *ngIf="tableLoader">
                    <div class="d-flex justify-content-center align-items-center ">
                        <app-loader></app-loader>
                    </div>
                </ng-container>
            </div>
        </ng-container> -->
        <!-- remove above section-->
         <ng-container *ngIf="isChildReportDataLoaded && currentPage && currentTab">
            <div class="row main-block ps-0 pages-row" *ngIf="pages?.length > 1" >
                <div class="col-12 d-flex align-items-center justify-content-between">
                    <app-inbuilt-pages-v2 [pages]="pages" [currentSelectedPage]="currentPage" (pageChange)="onPageChange($event)"></app-inbuilt-pages-v2>

                    <div class="documentation-icon documentation-icon-inline" *ngIf="isTabLabelEmpty">
                        <button [attr.Pixel-tracking]="true" [attr.Pixel-title]="'Documentation'"
                            class="uitk-icon uitk-icon-info_hollow md-icon no-border me-2 cursor-pointer" title="Info"
                            (click)="info()">
                        </button>
                    </div>
                </div>
            </div>
            
            <div class="row main-block p-relative">
                <div class="col-12">
                    <mat-tab-group (selectedTabChange)="onTabChange($event)" aria-label="Reports Tabs" role="tablist"
                        [ngClass]="{'hide-tab': isTabLabelEmpty}">
                        <mat-tab *ngFor="let tab of currentPage?.tabs; trackBy: trackByTab" [label]="tab.name" role="tab">
                            <ng-container *ngIf="currentTab.key === tab.key">
                                <div class="row widget-elements-row" *ngIf="!isPageChanging">
                                    <div #widgetHost class="report-widget-slot" *ngFor="let el of tab.elements; let elementIndex = index; trackBy: trackByElement" [ngClass]="[getElementLayoutClass(el, tab), shouldAddRowStartPadding(el, tab, elementIndex, tab.elements) ? 'ps-2' : '']">
                                        <ng-container [ngSwitch]="el.type">
                                            <div *ngSwitchCase="'filter'">
                                                <app-inbuilt-filters-v2 [config]="pageConfig" [showView]="showView" [elementData]="el" (onFiltersApplied)="handleTableAttribute($event)"></app-inbuilt-filters-v2>
                                            </div>
                                            <ng-container *ngIf="searchTriggered ">
                                                <div *ngSwitchCase="'table'">
                                                <app-inbuilt-table-v2 [config]="tableConfig" [elementData]="el"></app-inbuilt-table-v2>
                                            </div>
                                            <div *ngSwitchCase="'metrics'">
                                                <app-inbuilt-visual-wrapper-v2 [heading]="getElementWrapperTitle(el)" [elementData]="el" (navigateRequest)="navigateToPageOrExternalLink($event)">
                                                    <app-inbuilt-matrix [config]="tableConfig" [elementData]="el"></app-inbuilt-matrix>
                                                </app-inbuilt-visual-wrapper-v2>
                                            </div>
                                            <div *ngSwitchCase="'drill_down_matrix'">
                                                <app-inbuilt-visual-wrapper-v2 [heading]="getElementWrapperTitle(el)" [elementData]="el" (navigateRequest)="navigateToPageOrExternalLink($event)">
                                                    <app-inbuilt-drill-down-matrix [config]="tableConfig" [elementData]="el"></app-inbuilt-drill-down-matrix>
                                                </app-inbuilt-visual-wrapper-v2>
                                            </div>
                                            <div *ngSwitchCase="'parent_child_table'">
                                                <app-inbuilt-visual-wrapper-v2 [heading]="getElementWrapperTitle(el)" [elementData]="el" (navigateRequest)="navigateToPageOrExternalLink($event)">
                                                    <app-parent-child-table [config]="tableConfig" [elementData]="el"></app-parent-child-table>
                                                </app-inbuilt-visual-wrapper-v2>
                                            </div>
                                            <div *ngSwitchCase="'column_chart'">
                                                <app-inbuilt-visual-wrapper-v2 [heading]="el.resolvedHeading || getElementWrapperTitle(el)" [elementData]="el" (navigateRequest)="navigateToPageOrExternalLink($event)">
                                                    <app-column-chart-v2 [config]="tableConfig" [elementData]="el" (headingResolved)="el.resolvedHeading = $event"></app-column-chart-v2>
                                                </app-inbuilt-visual-wrapper-v2>
                                            </div>
                                            <div *ngSwitchCase="'bar_chart'">
                                                <app-inbuilt-visual-wrapper-v2 [heading]="el.resolvedHeading || getElementWrapperTitle(el)" [elementData]="el" (navigateRequest)="navigateToPageOrExternalLink($event)">
                                                    <app-inbuilt-bar-chart-v2 [config]="tableConfig" [elementData]="el" (headingResolved)="el.resolvedHeading = $event"></app-inbuilt-bar-chart-v2>
                                                </app-inbuilt-visual-wrapper-v2>
                                            </div>
                                            <div *ngSwitchCase="'header'">
                                                <app-inbuilt-visual-wrapper-v2 [heading]="getElementWrapperTitle(el)" [elementData]="el" (navigateRequest)="navigateToPageOrExternalLink($event)">
                                                    <app-inbuilt-header-v2 [config]="tableConfig" [elementData]="el"></app-inbuilt-header-v2>
                                                </app-inbuilt-visual-wrapper-v2>
                                            </div>
                                            <div *ngSwitchCase="'card'">
                                                <app-inbuilt-visual-wrapper-v2 [heading]="el.resolvedHeading || getElementWrapperTitle(el)" [elementData]="el" (navigateRequest)="navigateToPageOrExternalLink($event)">
                                                    <app-inbuilt-card-v2 [config]="tableConfig" [elementData]="el" (headingResolved)="el.resolvedHeading = $event"></app-inbuilt-card-v2>
                                                </app-inbuilt-visual-wrapper-v2>
                                            </div>
                                            <div *ngSwitchCase="'speedometer'">
                                                <app-inbuilt-visual-wrapper-v2 [heading]="getElementWrapperTitle(el)" [elementData]="el" (navigateRequest)="navigateToPageOrExternalLink($event)">
                                                    <app-inbuilt-speedometer-v2 [config]="tableConfig" [elementData]="el"></app-inbuilt-speedometer-v2>
                                                </app-inbuilt-visual-wrapper-v2>
                                            </div>
                                            <div *ngSwitchCase="'stat_card'">
                                                <app-inbuilt-visual-wrapper-v2 [heading]="el.resolvedHeading || getElementWrapperTitle(el)" [elementData]="el" (navigateRequest)="navigateToPageOrExternalLink($event)">
                                                    <app-inbuilt-stat-card [config]="tableConfig" [elementData]="el" (headingResolved)="el.resolvedHeading = $event"></app-inbuilt-stat-card>
                                                </app-inbuilt-visual-wrapper-v2>
                                            </div>
                                            <!-- <div *ngSwitchCase="'speedometer_v2'"> -->
                                                <!-- <app-inbuilt-visual-wrapper-v2 [heading]="getElementWrapperTitle(el)"> -->
                                                <!-- </app-inbuilt-visual-wrapper-v2> -->
                                            <!-- </div> -->
                                            
                                            </ng-container>
                                            <!-- add other element types here -->
                                        </ng-container>

                                    </div>
                                </div>
                                <div class="row">
                                    <!-- <div class="col-4">
                                                    <app-inbuilt-speedometer-v2 [config]="tableConfig" [elementData]="el"></app-inbuilt-speedometer-v2>

                                    </div> -->
                                    <!-- <div class="col-12">
                                                    <app-inbuilt-stat-card [config]="tableConfig" [elementData]="el"></app-inbuilt-stat-card>

                                    </div> -->
                                </div>
                            </ng-container>
                        </mat-tab>
                    </mat-tab-group>
                </div>
                <div class="documentation-icon" *ngIf="pages?.length <= 1 ">
                    <button [attr.Pixel-tracking]="true" [attr.Pixel-title]="'Documentation'"
                        class="uitk-icon uitk-icon-info_hollow md-icon no-border me-2  cursor-pointer" title="Info"
                        (click)="info()">
                    </button>
                </div>
    
            </div>
        </ng-container>
    
    </div>

</div>
<div class="inbuilt-loader-container" *ngIf="!showView">
    <div class="loader"><app-loader></app-loader></div>
    <div class="loader-text">
        <p>Please wait while we load the report</p>
    </div>
</div>

